import React from "react";
import { Skeleton } from "./Skeleton";

export const ProductSkeleton: React.FC = () => {
  return (
    <div className="bg-black-2 border-b border-r border-border-1 p-4.5">
      {/* Image Area */}
      <div className="h-44 bg-black/5 mb-4 rounded-sm animate-pulse" />
      
      {/* Category */}
      <Skeleton className="h-2 w-16 mb-2" />
      
      {/* Name */}
      <div className="space-y-2 mb-4">
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-3/4" />
      </div>
      
      {/* Price */}
      <Skeleton className="h-5 w-20 mb-3" />
      
      {/* Badge/Info */}
      <Skeleton className="h-2 w-24 mb-4" />
      
      {/* Button */}
      <Skeleton className="h-8 w-full" />
    </div>
  );
};
